import React from "react";
import { motion } from "framer-motion";
import { MANIFESTO } from "../../data/content";

export default function Manifesto() {
  return (
    <section id="series" className="section" data-testid="manifesto-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
          className="grid grid-cols-12 gap-6 md:gap-10 items-end mb-16 md:mb-24"
        >
          <div className="col-span-12 md:col-span-4">
            <p className="folio-num">Chapter Zero · Manifesto</p>
          </div>
          <h2 className="col-span-12 md:col-span-8 font-serif text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight">
            Books that teach the biggest ideas <em className="italic" style={{ color: "var(--accent-orange)" }}>in the smallest voices</em>.
          </h2>
        </motion.div>

        <div className="grid grid-cols-12 gap-8 md:gap-12">
          {MANIFESTO.map((m, i) => (
            <motion.article
              key={m.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
              className="col-span-12 md:col-span-6 border-t border-stone-900/15 pt-8"
              data-testid={`manifesto-chapter-${m.n}`}
            >
              <div className="flex items-baseline gap-6">
                <span className="font-serif text-5xl md:text-6xl leading-none text-stone-900">{m.n}</span>
                <span className="folio-num">§ {m.n}</span>
              </div>
              <h3 className="mt-6 font-serif text-3xl md:text-4xl leading-tight">{m.title}</h3>
              <p className="mt-4 text-stone-700 text-[16px] md:text-[17px] leading-relaxed max-w-xl">
                {m.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
